import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ui-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnInit {
  @Input() public control: FormControl<string | null> = new FormControl<string>(
    '',
  );
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() public isDisabled = false;
  @Input() public isMaterialLabel = true;
  @Input() public inputId = '';
  @Input() public rows = 1;
  @Input() public canResize = false;
  /** Character Counter UI limit.
   *
   * For example, if 50 is inputted, UI will show "0/50 characters"
   *
   * This is not in place of a Validator and should match the `control` input
   * max length validator if provided. */
  @Input() public characterCountLimit: number | undefined;

  public ngOnInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
  }

  public valueChanged(): void {
    this.control.markAsTouched();
    this.control.markAsDirty();
    this.control.updateValueAndValidity();
  }
}
